import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { UitkText } from "uitk-react-text";

import { validPrice } from "components/flexComponents/Hotels/utils/isValidPrice";
import { DATE_FORMAT } from "components/flexComponents/Hotels/utils/constants";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";

interface PriceLockupProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

const PriceLockup = ({
  hotel,
  align = UitkPriceLockupAlign.RIGHT,
  className = "",
  priceA11y,
  strikeThroughPrice,
}: PriceLockupProps) => {
  const { formattedPrice, isoCheckIn, isoCheckOut } = hotel;
  const { isValidPrice } = validPrice(hotel);

  const { formatText, formatDateString } = useLocalization();

  const checkInDateFormatted = formatDateString(isoCheckIn, { skeleton: DATE_FORMAT });
  const checkOutDateFormatted = formatDateString(isoCheckOut, { skeleton: DATE_FORMAT });

  return isValidPrice ? (
    <UitkPriceLockup
      lockupPrice={formattedPrice}
      priceSubtextFirst={formatText("hotels.price.perNight")}
      priceSubtextStandard={formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted)}
      a11yPrice={priceA11y?.getA11yText() || ""}
      strikeThroughPrice={strikeThroughPrice}
      align={align}
      className={className}
    />
  ) : (
    <UitkText size={600} weight="bold" className={`hotelPricing ${className}`}>
      {formatText("hotels.price.getRates")}
    </UitkText>
  );
};

export default PriceLockup;
